import CreateThirdParty from "./CreateThirdParty.container";

export default CreateThirdParty;
